import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Text } from './Text';
const StyledSectionTitle = styled.h4`
  label: JMT-General-SectionTitle;
  padding: ${p => p.padding || '15px 0'};
`;
export const SectionTitle = ({
  children,
  padding
}) => React.createElement(StyledSectionTitle, {
  padding: padding
}, React.createElement(Text, {
  isBold: true,
  fontSize: "1.3rem"
}, children));
SectionTitle.propTypes = {
  children: PropTypes.node.isRequired,
  padding: PropTypes.string
};
SectionTitle.defaultProps = {
  padding: ''
};